import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  signal,
} from '@angular/core';

@Component({
  selector: 'ss-www-play-button-overlay',
  imports: [],
  templateUrl: './play-button-overlay.component.html',
  styleUrls: ['./play-button-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlayButtonOverlayComponent {
  @Input() playButtonMessage = 'WATCH VIDEO';
  @Output() playClicked = new EventEmitter<void>();

  buttonHovered = signal<boolean>(false);
}
